<template>
    <div class="info-container">
        <v-simple-table class="table-container">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>#</th>
                        <th>%</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in statusCounts"
                        :key="item.alias"
                    >
                        <td :style="{ color: MSG_STATUS_COLORS[item.status] }" class="td-header">{{ item.status }}</td>
                        <td :style="{ color: MSG_STATUS_COLORS[item.status] }">{{ item.count }}</td>
                        <td :style="{ color: MSG_STATUS_COLORS[item.status] }">{{ getPercentage(item.count) }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
    import { MSG_STATUS_COLORS } from '@/utils/consts'

    export default {
        props: {
            statusCounts:
                {
                    type: Array,
                    required: false,
                    default: () => []
                }
        },
        data() {
            return {
                total: 0
            }
        },
        computed: {
            MSG_STATUS_COLORS() {
                return MSG_STATUS_COLORS
            }
        },
        watch: {
            statusCounts(newValue) {
                this.updateTotal(newValue)
            }
        },
        created() {
            this.updateTotal(this.statusCounts)
        },
        methods: {
            updateTotal(statusCounts) {
                this.total = statusCounts.reduce((sum, { count }) => sum + count, 0)
            },
            getPercentage(count) {
                return `${(count * 100 / this.total).toFixed(2)}%`
            }
        }
    }
</script>

<style scoped>

.table-container {
    width: 300px;
}

.td-header {
    font-weight: bold;
}

</style>
